// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1edf9f830383c2d8e1fc","655":"31b674fb3d6bf7f8725d"}[chunkId] + ".js";
};